export default __webpack_public_path__ + "static/47-1f219cb0d5a60e1a1428f30f1620051a.png";